module.exports = __webpack_public_path__ + "media/images/athletes/2785-b97865bd1b0e00ebc5138c798c5116b0.png";